<template>
  <div class=" p-4 justify-center ">
    <div class="justify-center flex mb-4">
      <span class="text-lg">Dieser Artikel befindet sich schon im Magazin auf Seite {{pagePosition}}</span>
    </div>
    <div class=" w-full flex " v-if="value.articleNumber !== null">
      <span class="bg-primary p-2 rounded">ArticleNumber</span>
      <div class="p-2" >{{value.articleNumber}}</div>
    </div>

    <button class="bg-trader-green w-full rounded p-2 mt-2" data-ui="product-is-on-magazine" @click="closeModal" >OK</button>

  </div>
</template>

<script>

import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import {eventBus} from "@/application/EventBus";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    pagePosition: {
      type: String,
      default: '0'
    }
  },

  data() {
    return {
    }
  },
  methods: {
    closeModal() {
      eventBus.closeModal();
    },
  },
  mounted() {

  }

}


</script>

